export default __webpack_public_path__ + "static/media/laundry1-beforeA-1440w.7d556bd7.png";